import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ConfirmationService} from 'primeng/api';
import {Subscription} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {ObjectBaseComponent} from '../../../../../core/shared/object/mvs-object-base/object-base.component';
import {MvsCoreService} from '../../../../../core/shared/service/mvs-core.service';
import {MvsMessageService} from '../../../../../core/shared/service/message/mvs-message.service';
import {ObserverService} from '../../../../../core/shared/object/service/observer.service';
import {NavigationItem} from '../../../../../core/shared/dto/navigation/navigation-item';
import {UfFlowTypeStepActivityDto} from '../../../model/dto/entity/uf-flow-type-step-activity.dto';

@Component({
    selector: 'uf-flow-type-step-activity-object-component',
    templateUrl: 'uf-flow-type-step-activity-object.component.html',
    styleUrls: ['uf-flow-type-step-activity-object.component.scss'],
    standalone: false
})
export class UfFlowTypeStepActivityObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    dto: UfFlowTypeStepActivityDto;

    navigationItems: NavigationItem[] = [
        {
            label: 'Übersicht',
            action: 'overview',
            tooltip: 'Übersicht der Schrittaktivität',
            icon: 'fa-regular fa-eye',
            toggleable: false,
            default: true
        }
    ];

    private queryParamSubscription: Subscription;

    constructor(
        protected coreService: MvsCoreService,
        protected messageService: MvsMessageService,
        protected confirmationService: ConfirmationService,
        protected override observerService: ObserverService,
        private route: ActivatedRoute
    ) {
        super(coreService, messageService, confirmationService, observerService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.subscribeToNavItemQueryParam();
    }

    onObjectChanged() {
        if (!this.activeNavigationItems) {
            this.activeNavigationItems = this.navigationItems[0];
        }
        this.onNavigationItems.emit(this.navigationItems);
    }

    private subscribeToNavItemQueryParam(): void {
        this.queryParamSubscription = this.route.queryParams.subscribe(params => {
            const navItem = params['navItem'];
            if (navItem) {
                const found = this.navigationItems.find(item => item.action === navItem);
                if (found) {
                    this.activeNavigationItems = found;
                }
            }
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        this.queryParamSubscription?.unsubscribe();
    }
}
